import { getCurrencyMinorUnit } from './get-currency-minor-unit.function';

/**
 * Returns true when `isoCode` is a valid ISO 4217 currency code.
 */
export function isValidCurrencyIsoCode(
  isoCode: string | null | undefined,
): boolean {
  try {
    getCurrencyMinorUnit(isoCode ?? '');
    return true;
  } catch {
    return false;
  }
}
